export*from"./generator";
//# sourceMappingURL=index.js.map